/**
 * Labstep
 *
 * @desc Protocol Version label
 */

import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { Label } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IProtocolVersionProps } from './types';

export const ProtocolVersion: React.FC<IProtocolVersionProps> = ({
  protocol,
  onClick,
}) => (
  <Label className={styles.label} onClick={onClick} circular>
    <span>{protocol.printVersion}</span>
    <Icon name="angle down" />
  </Label>
);
